export interface Quiz {
    quizSlides: SlideQuestionData[]
}

export interface SlideQuestionData {
    
    questionId: number,

    questionText: string,

    answers: SlideAnswerData[]
}

export interface SlideAnswerData {
    
    answerId: number,

    answerText: string,

    selected: boolean,

    answerType: QuizResultsType
}

export interface QuizResult {

    personalityType: string,

    personalityId: number,

    strengths: string,

    challenges: string,

    oneStepForward: string,

    cta: string
    
}

export enum QuizResultsType {
    VISIONARY_LEADER = 'Visionary Leader',
    BOUNDARY_SETTER = 'Boundary Setter',
    BALANCE_BUILDER = 'Balance Builder',
    MOMENTUM_MAKER = 'Momentum Maker'
}